import { NewsResponse, NewsRequest, NewsItem } from '@pff-consumer/schema/merlin-api'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { merlinEndpoints } from '@pff-consumer/api-sdk'
import { envConfig } from '@pff-consumer/utils'
import { isHydrateAction } from '../helpers/hydrateAction'

const { MERLIN_URL } = envConfig

// Define a service using a base URL and expected endpoints
export const merlinApi = createApi({
  reducerPath: 'merlinApi',
  baseQuery: fetchBaseQuery({
    baseUrl: MERLIN_URL,
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getPlayerNews: builder.query<NewsItem[], NewsRequest>({
      async queryFn(arg, listenerApi, _extraOptions, fetchWithBQ) {
        try {
          let news: NewsItem[] = []
          const playerNewsResponse = await fetchWithBQ(merlinEndpoints.getPlayerNews({ id: arg.playerId }).url)
          const playerNews = playerNewsResponse.data as NewsResponse
          if (playerNews?.posts) {
            news = [...playerNews.posts]
          }
          if (arg.teamId) {
            const teamNewsResponse = await fetchWithBQ(merlinEndpoints.getTeamNews({ id: arg.teamId }).url)
            const teamNews = teamNewsResponse.data as NewsResponse
            if (teamNews?.posts) {
              news = [...news, ...teamNews.posts]
            }
          }
          const limitNews = news.splice(0, arg.limit || news.length)
          const orderByDate = limitNews.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
          return { data: orderByDate }
        } catch (error) {
          return { data: [] }
        }
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPlayerNewsQuery,
  util: { getRunningQueriesThunk: getRunningQueriesThunkMerlin },
} = merlinApi
